import {
     LOADING_TRUE,
     LOADING_FALSE, 
     LOADING_TRUE2,
     LOADING_FALSE2, 
     GLOBAL_LOADING_TRUE, 
     GLOBAL_LOADING_FALSE, 
     LOADING_DATA_TRUE,
     LOADING_DATA_FALSE
} from "../types/loadingTypes";
  
  const INITIAL_STATE = {
    isLoading: false,
    isLoading2: false,
    globalLoading: true,
    data: ""
  };
  
  // eslint-disable-next-line import/no-anonymous-default-export
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case LOADING_TRUE:
          return {...state,
            isLoading: true,
        }
      case LOADING_FALSE:
        return {...state,
            isLoading: false,
        }
      case LOADING_DATA_TRUE:
          return {...state,
            data: action.payload,
        }
      case LOADING_DATA_FALSE:
        return {...state,
            data: action.payload,
        }
      case LOADING_TRUE2:
          return {...state,
            isLoading2: true,
        }
      case LOADING_FALSE2:
        return {...state,
            isLoading2: false,
        }
    case GLOBAL_LOADING_TRUE:
        return {...state,
            globalLoading: true,
        }
    case GLOBAL_LOADING_FALSE:
        return {...state,
            globalLoading: false,
        }
      default:
        return state;
    }
  };